import type { ReactNode } from 'react';

export interface PlaceholderCardProps {
  title: string;
  description?: string;
  /** Texto del badge. Default "Próximamente". */
  badge?: string;
  /**
   * Vista previa visual del contenido futuro (inputs deshabilitados, listas, etc).
   * Si no se pasa, renderiza un mensaje breve "Funcionalidad no disponible aún".
   */
  preview?: ReactNode;
}

export function PlaceholderCard({ title, description, badge = 'Próximamente', preview }: PlaceholderCardProps) {
  return (
    <div className="card" data-placeholder="true">
      <div className="card-head" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <span className="card-title">{title}</span>
        <span
          className="chip"
          style={{
            background: 'var(--bg-2)',
            color: 'var(--fg-muted)',
            fontSize: 11,
            fontWeight: 500,
            textTransform: 'uppercase',
            letterSpacing: 0.3,
          }}
        >
          {badge}
        </span>
      </div>
      {description && (
        <div style={{ padding: '12px 18px 0', fontSize: 12.5, color: 'var(--fg-muted)' }}>
          {description}
        </div>
      )}
      <div style={{ padding: '16px 18px', opacity: 0.55, pointerEvents: 'none' }}>
        {preview ?? (
          <p style={{ margin: 0, fontSize: 13, color: 'var(--fg-muted)' }}>
            Funcionalidad no disponible aún.
          </p>
        )}
      </div>
    </div>
  );
}
